import { render, staticRenderFns } from "./land-more-info.vue?vue&type=template&id=6aed43f8"
import script from "./land-more-info.vue?vue&type=script&lang=js"
export * from "./land-more-info.vue?vue&type=script&lang=js"
import style0 from "./land-more-info.vue?vue&type=style&index=0&id=6aed43f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports